// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.media-content {
  position: relative;
}

.media-content {
  position: relative;
}
.media-content .product__heading--activity {
  margin-bottom: 20px;
}
.media-content .product__heading--activity small {
  font-size: 65%;
  font-weight: 400;
}

.fixed-loader {
  width: 100%;
  height: 100%;
  text-align: center;
}
.fixed-loader i {
  font-size: 8em !important;
}

.iguide-download {
  width: 100%;
}

.mr-top-15 {
  margin-top: 10px;
}

/* iCheck plugin Square skin, green
----------------------------------- */
::ng-deep .ibox-content {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  /* HiDPI support */
}
::ng-deep .ibox-content--bdr {
  border: 0;
  padding-inline: 0;
}
::ng-deep .ibox-content .icheckbox_square-green,
::ng-deep .ibox-content .iradio_square-green {
  display: inline-block;
  *display: inline;
  vertical-align: middle;
  margin: 0;
  padding: 0;
  width: 22px;
  height: 22px;
  background: url("https://assets.foursightonline.com/app/images/green.png") no-repeat;
  border: none;
  cursor: pointer;
}
::ng-deep .ibox-content .icheckbox_square-green {
  background-position: 0 0;
}
::ng-deep .ibox-content .icheckbox_square-green.hover {
  background-position: -24px 0;
}
::ng-deep .ibox-content .icheckbox_square-green.checked {
  background-position: -48px 0;
}
::ng-deep .ibox-content .icheckbox_square-green.disabled {
  background-position: -72px 0;
  cursor: default;
}
::ng-deep .ibox-content .icheckbox_square-green.checked.disabled {
  background-position: -96px 0;
}
::ng-deep .ibox-content .iradio_square-green {
  background-position: -120px 0;
}
::ng-deep .ibox-content .iradio_square-green.hover {
  background-position: -144px 0;
}
::ng-deep .ibox-content .iradio_square-green.checked {
  background-position: -168px 0;
}
::ng-deep .ibox-content .iradio_square-green.disabled {
  background-position: -192px 0;
  cursor: default;
}
::ng-deep .ibox-content .iradio_square-green.checked.disabled {
  background-position: -216px 0;
}
@media (min-resolution: 120dpi) {
  ::ng-deep .ibox-content .icheckbox_square-green,
  ::ng-deep .ibox-content .iradio_square-green {
    background-image: url("https://assets.foursightonline.com/app/images/green@2x.png");
    background-size: 240px 24px;
  }
}

.package-form {
  display: inline-block;
  width: 50%;
  padding-right: 40px;
}
.package-form label,
.package-form select {
  width: 100%;
}
.package-form label {
  line-height: 2em;
  padding: 0.75rem 0.75rem 0.75rem 0 !important;
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}
.package-form select {
  border: 1px solid #ddd;
  padding: 10px !important;
  height: 40px;
  background: #F8F8F8;
  color: #636363;
  font-family: "Museo-300";
  margin-bottom: 10px;
}
.package-form select:focus {
  outline: none;
}

.iguide-download {
  width: 100%;
}
.iguide-download .warning {
  padding-top: 10px;
  display: block;
}

.mr-top-15 {
  margin-top: 10px;
}

::ng-deepul.inputs-list {
  padding-left: 0;
  list-style: none;
}

::ng-deepul.inputs-list input {
  margin-right: 10px;
}

::ng-deep#hubspotForm {
  margin-bottom: 10px;
}

::ng-deep.hs-error-msgs {
  display: none !important;
}

.mark-checkbox {
  margin-right: 5px;
}

.ibox--bdr {
  border: 0 !important;
}

.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: -ms-flexbox;
  display: block;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100vh;
  margin: 0 auto;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.single-box-nav .text-center span.scroll-btn a:after {
  width: unset;
}

.img--xtrahyt {
  min-height: 420px;
}

.image-imitation {
  --flexGap: 45px;
}
.image-imitation .audio-card {
  display: flex;
  justify-content: center;
  align-items: center;
}
.image-imitation .audio-card__player audio {
  height: var(--flexGap);
}
.image-imitation .audio-card__vol {
  width: var(--flexGap);
  height: var(--flexGap);
  background-color: #eee;
  border-radius: 50%;
  border: 0;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding-inline: 10px;
  margin-left: 10px;
}
.image-imitation .audio-card__ftrtextneg {
  border-radius: 30px;
  outline: none;
  box-shadow: none;
  height: 45px;
  margin-left: 10px;
  width: 100px;
  border: 0px;
}
.image-imitation .audio-card__ftrtextneg .fa {
  margin-right: 8px;
}
.image-imitation .audio-card__ftrauth {
  height: 45px;
  overflow: hidden;
  width: 45px;
  margin-right: 10px;
}
.image-imitation .audio-card__ftrauth img {
  border-radius: 50%;
}

@media only screen and (max-width: 991px) {
  ::ng-deep .coach-slider .page-heading {
    margin-bottom: 0 !important;
  }
}
::ng-deep .coach-slider .ibox {
  position: relative;
}
::ng-deep .coach-slider .ibox__close {
  position: absolute;
  right: 11px;
  z-index: 9;
  top: 20px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .coach-slider .ibox__close {
    right: 35px;
  }
}
::ng-deep .coach-slider .ibox__close a {
  border-radius: 50%;
  border: 1px solid #CFDBE2;
  padding: 4px 8px;
}
@media only screen and (max-width: 991px) and (orientation: landscape) {
  ::ng-deep .coach-slider .ibox-footer {
    display: flex;
    margin: 0 auto;
  }
  ::ng-deep .coach-slider .ibox-footer .next-link {
    padding-right: 60px;
  }
}
::ng-deep .coach-slider .ibox-footer .single-box-nav {
  display: flex;
  justify-content: space-between;
}
::ng-deep .coach-slider .ibox-footer .single-box-nav a {
  font-size: 14px !important;
}
::ng-deep .coach-slider .ibox-footer .col-xs-3 {
  width: 50%;
  padding-left: 5px;
  padding-right: 5px;
}
::ng-deep .coach-slider .ibox-content .single-card-link {
  padding: 10px 0;
}
::ng-deep .coach-slider .ibox-content hr {
  display: none;
}
::ng-deep .coach-slider .ibox-content br {
  display: none;
}
::ng-deep .coach-slider .ibox-content .card-description {
  padding-bottom: 25px;
}
::ng-deep .coach-slider .ibox-content .card-description p {
  margin: 0;
  font-size: 14px;
  color: #676a6c;
}
::ng-deep .coach-slider-footer {
  padding: 10px 0px;
}
::ng-deep .coach-slider-footer .single-box-nav {
  display: flex;
  justify-content: space-between;
}
::ng-deep .coach-slider-footer .single-box-nav a {
  font-size: 14px !important;
}
::ng-deep .coach-slider-footer .image-imitation {
  box-shadow: none;
}
::ng-deep .coach-slider-footer .image-imitation .audio-card audio {
  max-width: 100%;
}
@media only screen and (max-width: 480px) {
  ::ng-deep .coach-slider-footer .image-imitation .audio-card {
    transform: scale(0.8);
  }
  ::ng-deep .coach-slider-footer .image-imitation .audio-card__vol, ::ng-deep .coach-slider-footer .image-imitation .audio-card__ftrtextneg {
    display: none;
  }
  ::ng-deep .coach-slider-footer .image-imitation .audio-card audio::-webkit-media-controls-volume-slider,
  ::ng-deep .coach-slider-footer .image-imitation .audio-card audio::-webkit-media-controls-mute-button,
  ::ng-deep .coach-slider-footer .image-imitation .audio-card audio::-webkit-media-controls-volume-slider-container {
    display: block;
  }
}
::ng-deep .coach-slider-footer .image-imitation .audio-card__ftrauth {
  height: 36px;
  width: 36px;
  margin-right: 5px;
}
::ng-deep .coach-slider-footer .image-imitation .audio-card__vol {
  margin-left: 10px;
  height: 26px;
  width: 26px;
}
::ng-deep .coach-slider-footer .image-imitation .audio-card__ftrtextneg {
  width: 55px;
  height: 26px;
}
::ng-deep .coach-slider-footer .image-imitation .audio-card__ftrtextneg span {
  font-size: 10px;
}
::ng-deep .coach-slider-footer .image-imitation .audio-card__ftrtextneg span i {
  margin-right: 4px;
}
::ng-deep .coach-slider-content .single-card-link {
  padding: 10px 0;
}
::ng-deep .coach-slider-content hr {
  display: none;
}
::ng-deep .coach-slider-content br {
  display: none;
}
::ng-deep .coach-slider-content .card-description {
  padding-bottom: 25px;
}
::ng-deep .coach-slider-content .card-description p {
  margin: 0;
  font-size: 14px;
  color: #676A6C;
}

.media-content__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
}
.media-content__audio {
  align-items: flex-start;
  min-height: auto;
  padding-bottom: 15px;
}
.media-content .image-imitation {
  box-shadow: none;
}
.media-content .image-imitation .audio-card audio {
  max-width: 100%;
}
@media only screen and (max-width: 480px) {
  .media-content .image-imitation .audio-card {
    transform: scale(0.8);
  }
  .media-content .image-imitation .audio-card__vol, .media-content .image-imitation .audio-card__ftrtextneg {
    display: none;
  }
  .media-content .image-imitation .audio-card audio::-webkit-media-controls-volume-slider,
  .media-content .image-imitation .audio-card audio::-webkit-media-controls-mute-button,
  .media-content .image-imitation .audio-card audio::-webkit-media-controls-volume-slider-container {
    display: block;
  }
}
.media-content .image-imitation .audio-card__ftrauth {
  height: 36px;
  width: 36px;
  margin-right: 5px;
}
.media-content .image-imitation .audio-card__vol {
  margin-left: 10px;
  height: 26px;
  width: 26px;
}
.media-content .image-imitation .audio-card__ftrtextneg {
  width: 55px;
  height: 26px;
}
.media-content .image-imitation .audio-card__ftrtextneg span {
  font-size: 10px;
}
.media-content .image-imitation .audio-card__ftrtextneg span i {
  margin-right: 4px;
}

.white-bg.page-heading.challenge-coach {
  margin-top: -20px;
  margin-bottom: 20px;
}
.white-bg.page-heading.challenge-coach .breadcrumb {
  font-size: 12px;
}
.white-bg.page-heading.challenge-coach .button-wrapper-flex-right {
  width: 10%;
}
.white-bg.page-heading.challenge-coach .col-lg-10 {
  width: 90%;
}

.dc-single__inner .ibox-content .media-content h2 small {
  font-size: 65%;
  line-height: 1;
  font-weight: 400;
}
.dc-single hr {
  margin-top: 20px;
  margin-bottom: 20px;
  border: 0;
  border-top: 1px solid #eeeeee;
}

@media (max-width: 1440px) {
  .product-detail .ibox-content .f-flex .media-content {
    width: 50%;
  }
}
@media (min-width: 769px) and (max-width: 991px), (max-width: 640px) {
  .product-detail .ibox-content .f-flex .media-content {
    width: 100%;
    padding-inline: 15px;
  }
}
@media (max-width: 1440px) {
  .product-detail .ibox-content .f-flex .media-content + .media-content {
    padding-right: 15px;
  }
}
@media (min-width: 769px) and (max-width: 991px), (max-width: 640px) {
  .product-detail .ibox-footer .single-box-nav .text-left a:before {
    font-size: 20px;
    left: -24px;
  }
}
@media (min-width: 769px) and (max-width: 991px), (max-width: 640px) {
  .product-detail .ibox-footer .single-box-nav .text-left {
    padding-left: 0;
  }
}
@media (min-width: 769px) and (max-width: 991px), (max-width: 640px) {
  .product-detail .ibox-footer .single-box-nav .text-center span.scroll-btn a:after {
    height: 20px;
    bottom: -19px;
    width: 100% !important;
    border: none;
    background: #666;
    clip-path: polygon(102% 0%, -2% 0, 50% 100%);
    left: 0;
  }
}
@media (min-width: 769px) and (max-width: 991px), (max-width: 640px) {
  .product-detail .ibox-footer .single-box-nav .text-right a:after {
    font-size: 20px;
    right: -24px;
  }
}
@media (min-width: 769px) and (max-width: 991px), (max-width: 640px) {
  .product-detail .ibox-footer .single-box-nav .text-right {
    padding-right: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/learner-maps/dynamic-learner-map/dynamic-card-single/dynamic-card-single.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AAzYA;EACE,kBAAA;AA4YF;;AAzYA;EACE,kBAAA;AA4YF;AAzYI;EACE,mBAAA;AA2YN;AAzYM;EACE,cAAA;EACA,gBAAA;AA2YR;;AArYA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAwYF;AAtYE;EACE,yBAAA;AAwYJ;;AApYA;EACE,WAAA;AAuYF;;AApYA;EACE,gBAAA;AAuYF;;AApYA;qCAAA;AAGA;EACE,4BAAA;EACA,sBAAA;EACA,2BAAA;EA+DA,kBAAA;AAwUF;AArYE;EACE,SAAA;EACA,iBAAA;AAuYJ;AApYE;;EAEE,qBAAA;GAsYF,eArYE;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oFAAA;EACA,YAAA;EACA,eAAA;AAsYJ;AAnYE;EACE,wBAAA;AAqYJ;AAlYE;EACE,4BAAA;AAoYJ;AAjYE;EACE,4BAAA;AAmYJ;AAhYE;EACE,4BAAA;EACA,eAAA;AAkYJ;AA/XE;EACE,4BAAA;AAiYJ;AA9XE;EACE,6BAAA;AAgYJ;AA7XE;EACE,6BAAA;AA+XJ;AA5XE;EACE,6BAAA;AA8XJ;AA3XE;EACE,6BAAA;EACA,eAAA;AA6XJ;AA1XE;EACE,6BAAA;AA4XJ;AAxXE;EAIE;;IAEE,mFAAA;IAEA,2BAAA;EAuXJ;AACF;;AAnXA;EACE,qBAAA;EACA,UAAA;EACA,mBAAA;AAsXF;AApXE;;EAEE,WAAA;AAsXJ;AAnXE;EACE,gBAAA;EACA,6CAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAqXJ;AAlXE;EACE,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,mBAAA;AAoXJ;AAjXE;EACE,aAAA;AAmXJ;;AA/WA;EACE,WAAA;AAkXF;AAhXE;EACE,iBAAA;EACA,cAAA;AAkXJ;;AA9WA;EACE,gBAAA;AAiXF;;AA9WA;EACE,eAAA;EACA,gBAAA;AAiXF;;AA9WA;EACE,kBAAA;AAiXF;;AA9WA;EACE,mBAAA;AAiXF;;AA9WA;EACE,wBAAA;AAiXF;;AA9WA;EACE,iBAAA;AAiXF;;AA7WE;EACE,oBAAA;AAgXJ;;AA5WA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EAEA,oBAAA;EACA,cAAA;EAGA,uBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AA+WF;;AA5WA;EACE,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AA+WF;;AA5WA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AA+WF;;AA3WA;EACE,mCAAA;EACA,UAAA;AA8WF;;AA3WA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AA8WF;;AA3WA;EACE,mCAAA;EACA,mBAAA;EACA,UAAA;AA8WF;;AA3WA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AA8WF;;AA3WA;EACE;IACE,UAAA;EA8WF;EA3WA;IACE,UAAA;EA6WF;EA1WA;IACE,UAAA;EA4WF;AACF;AApWU;EACE,YAAA;AAsWZ;;AA7VE;EACE,iBAAA;AAgWJ;;AA5VA;EACE,eAAA;AA+VF;AA7VE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AA+VJ;AA3VM;EACE,sBAAA;AA6VR;AAzVI;EACE,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;AA2VN;AAxVI;EACE,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;AA0VN;AAxVM;EACE,iBAAA;AA0VR;AAtVI;EACE,YAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAwVN;AAtVM;EACE,kBAAA;AAwVR;;AA/UI;EADF;IAEI,2BAAA;EAmVJ;AACF;AAhVE;EACE,kBAAA;AAkVJ;AAhVI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;AAkVN;AAhVM;EANF;IAOI,WAAA;EAmVN;AACF;AAjVM;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;AAmVR;AA5UM;EAHF;IAII,aAAA;IAEA,cAAA;EA8UN;EA5UM;IACE,mBAAA;EA8UR;AACF;AA3UM;EACE,aAAA;EACA,8BAAA;AA6UR;AA3UQ;EACE,0BAAA;AA6UV;AAxUM;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AA0UR;AApUM;EACE,eAAA;AAsUR;AAnUM;EACE,aAAA;AAqUR;AAlUM;EACE,aAAA;AAoUR;AAjUM;EACE,oBAAA;AAmUR;AAjUQ;EACE,SAAA;EACA,eAAA;EACA,cD3YW;AC8sBrB;AA3TE;EACE,iBAAA;AA6TJ;AA3TI;EACE,aAAA;EACA,8BAAA;AA6TN;AA3TM;EACE,0BAAA;AA6TR;AAxTI;EACE,gBAAA;AA0TN;AArTQ;EACE,eAAA;AAuTV;AApTQ;EANF;IAOI,qBAAA;EAuTR;EArTQ;IAEE,aAAA;EAsTV;EAnTQ;;;IAGE,cAAA;EAqTV;AACF;AAjTQ;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AAmTV;AAhTQ;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AAkTV;AA9SQ;EACE,WAAA;EACA,YAAA;AAgTV;AA9SU;EACE,eAAA;AAgTZ;AA9SY;EACE,iBAAA;AAgTd;AArSI;EACE,eAAA;AAuSN;AApSI;EACE,aAAA;AAsSN;AAnSI;EACE,aAAA;AAqSN;AAlSI;EACE,oBAAA;AAoSN;AAlSM;EACE,SAAA;EACA,eAAA;EACA,cAAA;AAoSR;;AA1RE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AA6RJ;AA1RE;EACE,uBAAA;EACA,gBAAA;EACA,oBAAA;AA4RJ;AAzRE;EACE,gBAAA;AA2RJ;AAtRM;EACE,eAAA;AAwRR;AArRM;EANF;IAOI,qBAAA;EAwRN;EAtRM;IAEE,aAAA;EAuRR;EApRM;;;IAGE,cAAA;EAsRR;AACF;AAlRM;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AAoRR;AAjRM;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AAmRR;AA/QM;EACE,WAAA;EACA,YAAA;AAiRR;AA/QQ;EACE,eAAA;AAiRV;AA/QU;EACE,iBAAA;AAiRZ;;AApQI;EACE,iBAAA;EACA,mBAAA;AAuQN;AArQM;EACE,eAAA;AAuQR;AApQM;EACE,UAAA;AAsQR;AAnQM;EACE,UAAA;AAqQR;;AAnPY;EACE,cAAA;EACA,cAAA;EACA,gBAAA;AAsPd;AA9OE;EACE,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;AAgPJ;;AArOQ;EADF;IAEI,UAAA;EAyOR;AACF;AAvOQ;EALF;IAOI,WAAA;IACA,oBAAA;EAyOR;AACF;AAtOU;EADF;IAEI,mBAAA;EAyOV;AACF;AAzNY;EAFF;IAII,eAAA;IACA,WAAA;EA2NZ;AACF;AAvNQ;EAdF;IAgBI,eAAA;EAyNR;AACF;AA5MgB;EAFF;IAII,YAAA;IACA,aAAA;IACA,sBAAA;IACA,YAAA;IACA,gBAAA;IACA,4CAAA;IACA,OAAA;EA8MhB;AACF;AAjMY;EAFF;IAII,eAAA;IACA,YAAA;EAmMZ;AACF;AA/LQ;EAdF;IAgBI,gBAAA;EAiMR;AACF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import 'assets/styles/variables';\n$assets: 'https://assets.foursightonline.com/app';\n\n$mq-large-mob: 'only screen and (max-width: 480px)';\n\n\n.media-content {\n  position: relative;\n}\n\n.media-content {\n  position: relative;\n\n  .product__heading {\n    &--activity {\n      margin-bottom: 20px;\n\n      small {\n        font-size: 65%;\n        font-weight: 400;\n      }\n    }\n  }\n}\n\n.fixed-loader {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n\n  i {\n    font-size: 8em !important;\n  }\n}\n\n.iguide-download {\n  width: 100%;\n}\n\n.mr-top-15 {\n  margin-top: 10px;\n}\n\n/* iCheck plugin Square skin, green\n----------------------------------- */\n\n::ng-deep .ibox-content {\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n\n  &--bdr {\n    border: 0;\n    padding-inline: 0;\n  }\n\n  .icheckbox_square-green,\n  .iradio_square-green {\n    display: inline-block;\n    *display: inline;\n    vertical-align: middle;\n    margin: 0;\n    padding: 0;\n    width: 22px;\n    height: 22px;\n    background: url($assets+'/images/green.png') no-repeat;\n    border: none;\n    cursor: pointer;\n  }\n\n  .icheckbox_square-green {\n    background-position: 0 0;\n  }\n\n  .icheckbox_square-green.hover {\n    background-position: -24px 0;\n  }\n\n  .icheckbox_square-green.checked {\n    background-position: -48px 0;\n  }\n\n  .icheckbox_square-green.disabled {\n    background-position: -72px 0;\n    cursor: default;\n  }\n\n  .icheckbox_square-green.checked.disabled {\n    background-position: -96px 0;\n  }\n\n  .iradio_square-green {\n    background-position: -120px 0;\n  }\n\n  .iradio_square-green.hover {\n    background-position: -144px 0;\n  }\n\n  .iradio_square-green.checked {\n    background-position: -168px 0;\n  }\n\n  .iradio_square-green.disabled {\n    background-position: -192px 0;\n    cursor: default;\n  }\n\n  .iradio_square-green.checked.disabled {\n    background-position: -216px 0;\n  }\n\n  /* HiDPI support */\n  @media (-o-min-device-pixel-ratio: 5/4),\n  (-webkit-min-device-pixel-ratio: 1.25),\n  (min-resolution: 120dpi) {\n\n    .icheckbox_square-green,\n    .iradio_square-green {\n      background-image: url($assets+'/images/green@2x.png');\n      -webkit-background-size: 240px 24px;\n      background-size: 240px 24px;\n    }\n  }\n}\n\n.package-form {\n  display: inline-block;\n  width: 50%;\n  padding-right: 40px;\n\n  label,\n  select {\n    width: 100%;\n  }\n\n  label {\n    line-height: 2em;\n    padding: .75rem .75rem .75rem 0 !important;\n    display: inline-block;\n    max-width: 100%;\n    margin-bottom: 5px;\n    font-weight: 700;\n  }\n\n  select {\n    border: 1px solid #ddd;\n    padding: 10px !important;\n    height: 40px;\n    background: #F8F8F8;\n    color: #636363;\n    font-family: 'Museo-300';\n    margin-bottom: 10px;\n  }\n\n  select:focus {\n    outline: none;\n  }\n}\n\n.iguide-download {\n  width: 100%;\n\n  .warning {\n    padding-top: 10px;\n    display: block;\n  }\n}\n\n.mr-top-15 {\n  margin-top: 10px;\n}\n\n::ng-deepul.inputs-list {\n  padding-left: 0;\n  list-style: none;\n}\n\n::ng-deepul.inputs-list input {\n  margin-right: 10px;\n}\n\n::ng-deep#hubspotForm {\n  margin-bottom: 10px;\n}\n\n::ng-deep.hs-error-msgs {\n  display: none !important;\n}\n\n.mark-checkbox {\n  margin-right: 5px;\n}\n\n.ibox {\n  &--bdr {\n    border: 0 !important;\n  }\n}\n\n.loader-container {\n  position: absolute;\n  left: 0;\n  right: 0;\n  text-align: center;\n  top: 0;\n  bottom: 0;\n  background: rgba(236, 236, 236, .9);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: block;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  z-index: 9999999999;\n  height: 100vh;\n  margin: 0 auto;\n}\n\n.loader-spin {\n  background-color: hsla(0, 0%, 92.5%, .9);\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.loader__inner {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n\n}\n\n#Path_129 {\n  animation: blink 2s linear infinite;\n  opacity: 0;\n}\n\n#Path_130 {\n  animation: blink 2s linear infinite;\n  animation-delay: .5s;\n  opacity: 0;\n}\n\n#Path_132 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1s;\n  opacity: 0;\n}\n\n#Path_131 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1.5s;\n  opacity: 0;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n.single-box-nav {\n  .text-center {\n    span {\n      &.scroll-btn {\n        a {\n          &:after {\n            width: unset;\n          }\n        }\n      }\n    }\n  }\n}\n\n.img {\n  &--xtrahyt {\n    min-height: 420px;\n  }\n}\n\n.image-imitation {\n  --flexGap: 45px;\n\n  .audio-card {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &__player {\n\n      audio {\n        height: var(--flexGap);\n      }\n    }\n\n    &__vol {\n      width: var(--flexGap);\n      height: var(--flexGap);\n      background-color: #eee;\n      border-radius: 50%;\n      border: 0;\n      cursor: pointer;\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n      align-items: center;\n      padding-inline: 10px;\n      margin-left: 10px;\n    }\n\n    &__ftrtextneg {\n      border-radius: 30px;\n      outline: none;\n      box-shadow: none;\n      height: 45px;\n      margin-left: 10px;\n      width: 100px;\n      border: 0px;\n\n      .fa {\n        margin-right: 8px;\n      }\n    }\n\n    &__ftrauth {\n      height: 45px;\n      overflow: hidden;\n      width: 45px;\n      margin-right: 10px;\n\n      img {\n        border-radius: 50%;\n      }\n    }\n  }\n}\n\n::ng-deep .coach-slider {\n\n  .page-heading {\n    @media #{$tablet} {\n      margin-bottom: 0 !important;\n    }\n  }\n\n  .ibox {\n    position: relative;\n\n    &__close {\n      position: absolute;\n      right: 11px;\n      z-index: 9;\n      top: 20px;\n\n      @media #{$tablet} {\n        right: 35px;\n      }\n\n      a {\n        border-radius: 50%;\n        border: 1px solid #CFDBE2;\n        padding: 4px 8px;\n      }\n    }\n\n    &-footer {\n      // padding: 10px 0px;\n\n      @media #{$tablet} and (orientation: landscape) {\n        display: flex;\n        // max-width: 83%;\n        margin: 0 auto;\n\n        .next-link {\n          padding-right: 60px;\n        }\n      }\n\n      .single-box-nav {\n        display: flex;\n        justify-content: space-between;\n\n        a {\n          font-size: 14px !important;\n        }\n\n      }\n\n      .col-xs-3 {\n        width: 50%;\n        padding-left: 5px;\n        padding-right: 5px;\n      }\n    }\n\n    &-content {\n\n      .single-card-link {\n        padding: 10px 0;\n      }\n\n      hr {\n        display: none;\n      }\n\n      br {\n        display: none;\n      }\n\n      .card-description {\n        padding-bottom: 25px;\n\n        p {\n          margin: 0;\n          font-size: 14px;\n          color: $body-content-color;\n        }\n\n      }\n    }\n\n  }\n\n  &-footer {\n    padding: 10px 0px;\n\n    .single-box-nav {\n      display: flex;\n      justify-content: space-between;\n\n      a {\n        font-size: 14px !important;\n      }\n\n    }\n\n    .image-imitation {\n      box-shadow: none;\n\n\n      .audio-card {\n\n        audio {\n          max-width: 100%;\n        }\n\n        @media #{$mq-large-mob} {\n          transform: scale(0.8);\n\n          &__vol,\n          &__ftrtextneg {\n            display: none;\n          }\n\n          audio::-webkit-media-controls-volume-slider,\n          audio::-webkit-media-controls-mute-button,\n          audio::-webkit-media-controls-volume-slider-container {\n            display: block;\n          }\n\n        }\n\n        &__ftrauth {\n          height: 36px;\n          width: 36px;\n          margin-right: 5px;\n        }\n\n        &__vol {\n          margin-left: 10px;\n          height: 26px;\n          width: 26px;\n\n        }\n\n        &__ftrtextneg {\n          width: 55px;\n          height: 26px;\n\n          span {\n            font-size: 10px;\n\n            i {\n              margin-right: 4px;\n            }\n          }\n        }\n      }\n\n    }\n  }\n\n  &-content {\n\n    .single-card-link {\n      padding: 10px 0;\n    }\n\n    hr {\n      display: none;\n    }\n\n    br {\n      display: none;\n    }\n\n    .card-description {\n      padding-bottom: 25px;\n\n      p {\n        margin: 0;\n        font-size: 14px;\n        color: #676A6C;\n      }\n\n    }\n  }\n\n}\n\n.media-content {\n\n  &__head {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-right: 10px;\n  }\n\n  &__audio {\n    align-items: flex-start;\n    min-height: auto;\n    padding-bottom: 15px;\n  }\n\n  .image-imitation {\n    box-shadow: none;\n\n\n    .audio-card {\n\n      audio {\n        max-width: 100%;\n      }\n\n      @media #{$mq-large-mob} {\n        transform: scale(0.8);\n\n        &__vol,\n        &__ftrtextneg {\n          display: none;\n        }\n\n        audio::-webkit-media-controls-volume-slider,\n        audio::-webkit-media-controls-mute-button,\n        audio::-webkit-media-controls-volume-slider-container {\n          display: block;\n        }\n\n      }\n\n      &__ftrauth {\n        height: 36px;\n        width: 36px;\n        margin-right: 5px;\n      }\n\n      &__vol {\n        margin-left: 10px;\n        height: 26px;\n        width: 26px;\n\n      }\n\n      &__ftrtextneg {\n        width: 55px;\n        height: 26px;\n\n        span {\n          font-size: 10px;\n\n          i {\n            margin-right: 4px;\n          }\n        }\n      }\n    }\n\n  }\n}\n\n.white-bg {\n\n  &.page-heading {\n\n    &.challenge-coach {\n      margin-top: -20px;\n      margin-bottom: 20px;\n\n      .breadcrumb {\n        font-size: 12px;\n      }\n\n      .button-wrapper-flex-right {\n        width: 10%;\n      }\n\n      .col-lg-10 {\n        width: 90%;\n      }\n    }\n  }\n}\n\n.dc-single {\n\n  &__inner {\n\n    .ibox {\n\n      &-content {\n\n        .media-content {\n\n          h2 {\n\n            small {\n              font-size: 65%;\n              line-height: 1;\n              font-weight: 400;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  hr {\n    margin-top: 20px;\n    margin-bottom: 20px;\n    border: 0;\n    border-top: 1px solid #eeeeee;\n  }\n}\n\n.product-detail {\n\n  .ibox-content {\n\n    .f-flex {\n\n      .media-content {\n        @media (max-width: 1440px) {\n          width: 50%;\n        }\n\n        @media (min-width: 769px) and (max-width: 991px),\n        (max-width: 640px) {\n          width: 100%;\n          padding-inline: 15px;\n        }\n\n        &+.media-content {\n          @media (max-width: 1440px) {\n            padding-right: 15px;\n          }\n        }\n      }\n    }\n  }\n\n  .ibox-footer {\n\n    .single-box-nav {\n\n      .text-left {\n\n        a {\n\n          &:before {\n\n            @media (min-width: 769px) and (max-width: 991px),\n            (max-width: 640px) {\n              font-size: 20px;\n              left: -24px;\n            }\n          }\n        }\n\n        @media (min-width: 769px) and (max-width: 991px),\n        (max-width: 640px) {\n          padding-left: 0;\n        }\n      }\n\n      .text-center {\n\n        span {\n\n          &.scroll-btn {\n\n            a {\n\n              &:after {\n\n                @media (min-width: 769px) and (max-width: 991px),\n                (max-width: 640px) {\n                  height: 20px;\n                  bottom: -19px;\n                  width: 100% !important;\n                  border: none;\n                  background: #666;\n                  clip-path: polygon(102% 0%, -2% 0, 50% 100%);\n                  left: 0;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .text-right {\n\n        a {\n\n          &:after {\n\n            @media (min-width: 769px) and (max-width: 991px),\n            (max-width: 640px) {\n              font-size: 20px;\n              right: -24px;\n            }\n          }\n        }\n\n        @media (min-width: 769px) and (max-width: 991px),\n        (max-width: 640px) {\n          padding-right: 0;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
